import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';

const StyledForm = styled('form')({
  marginRight: 6,
  maxWidth: '60%',
  flex: 1,
  display: 'flex',
  [mediaQuery(1200)]: {
    maxWidth: '75%',
  },
  [mediaQuery(1024)]: {
    marginRight: 0,
    maxWidth: 'none',
  },
});

export default StyledForm;
